<template>
    <div class="o-d-guide-search d-guide-search">
        <div class="d-guide-search__header">
            <MExtremePoint
                :theme="mode"
                clearable
                searchbale
                ref="extremePoint"
                v-model="value"
                :label="inputLabel"
                :placeholder="$t(`d-guide-search-placeholder--${mode}`)"
                @onChange="handleInput"
                @onClear="handleClear"
            />
        </div>
        <div class="d-guide-search__container">
            <component
                guide
                :id="id"
                :item="item"
                :mode="mode"
                :items="defineItems"
                :placeholders="placeholders"
                :is="defineComponent"
                :filteredByItem="filteredByItem"
                :hasStrictResult="hasStrictResult"
                @onTileClick="handleTileClick"
                @onMenuClick="handleComponent"
                @onSearchTileClick="handleTileClick"
            />
        </div>
        <AMBackButton
            v-if="isShowBackButton"
            theme="back"
            :text="$t('ui.back')"
            class="d-guide-search__back-button"
            @onClick="handleBack"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ODCare from '../../unique-organisms/o-d-care/o-d-care';
import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import ODService from '../../unique-organisms/o-d-service/o-d-service';
import ODServices from '../../unique-organisms/o-d-services/o-d-services';
import OSearchresult from '../../organisms/o-searchresult/o-searchresult';
import MExtremePoint from '../../molecules/m-extreme-point/m-extreme-point';
import OMainCategoryMenu from '../../organisms/o-main-category-menu/o-main-category-menu';

import {
    GUIDE_JUMP_TO,
    SUCCESS_SEARCH,
    GUIDE_NEW_POINT,
    UNSUCCESS_SEARCH,
    GUIDE_CLOSE_SEARCHBAR
} from "../../../utils/constants/bus-events-constants";

import search from "../../../utils/mixins/search";

export default {
    name: 'ODGuideSearch',
    components: {
        ODCare,
        ODService,
        ODServices,
        AMBackButton,
        OSearchresult,
        MExtremePoint,
        OMainCategoryMenu
    },
    data() {
        return {
            id: null,
            menu: true,
            currentUnit: 'menu',
            placeholders: null,
            units: {
                care: 'ODCare',
                service: 'ODService',
                services: 'ODServices',
                menu: 'OMainCategoryMenu',
                searchresult: 'OSearchresult'
            }
        }
    },
    mixins: [search],
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        mode: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            't'
        ]),
        defineItems() {
            // TODO: replace with arr generator
            const placeholders = [{}, {}, {}, {}, {}, {}, {}, {}];
            return this.placeholders ? placeholders : this.getItems
        },
        defineComponent() {
            return this.units[this.currentUnit];
        },
        isShowBackButton() {
            return this.currentUnit === 'searchresult' || this.currentUnit === 'menu';
        },
        inputLabel() {
            return this.mode === 'start' ? this.$t('ui.start') : this.$t('ui.finish');
        },
        filteredByItem() {
            return this.mode === 'start' ? parseInt(this.$route.query.to, 10) : this.$route.query.from ? parseInt(this.$route.query.from, 10) : null;
        }
    },
    mounted() {
        this.initEventsListeners();
    },
    beforeDestroy() {
        this.deactivateEventListeners();
    },
    watch: {
        value(data) {
            data && !this.menu ? this.currentUnit = 'searchresult' : this.currentUnit = 'menu';
        }
    },
    methods: {
        initEventsListeners() {
            this.$bus.$on(GUIDE_JUMP_TO, this.handleComponent);
        },
        deactivateEventListeners() {
            this.$bus.$off(GUIDE_JUMP_TO, this.handleComponent);
        },
        handleBack() {
            if(this.value) {
                this.$bus.$emit(UNSUCCESS_SEARCH)
            }
            this.$bus.$emit(GUIDE_CLOSE_SEARCHBAR, true);
        },
        handleClickBack(data) {
            this.currentUnit = data;
        },
        handleComponent(unit) {
            if (unit !== 'menu') this.menu = false;
            this.currentUnit = unit;
        },
        focusAndSelectInputValue() {
            const el = this.$refs.extremePoint.$refs.extremePointInput;
            el.focus();
            el.setSelectionRange(0, this.value.length);
        },
        handleInput() {
            this.menu = !this.value;
        },
        handleTileClick(data) {
            this.value && this.$bus.$emit(SUCCESS_SEARCH, {
                value1: this.value,
                value2: "found",
                value3: "request_guide",
                target: 'object',
                target_type: data.type,
                target_id: data.id,
            })
            if (data.type === 'tenant' || data.type === 'service') {
                const params = this.mode === 'start' ? 'start' : 'finish';
                this.$bus.$emit(GUIDE_NEW_POINT, {
                    mode: params,
                    ...data
                });
            } else {
                this.id = data.id;
                this.handleComponent(this.menu ? 'services' : 'service');
            }
        }
    }
}
</script>

<style lang="scss">
@import "o-d-guide-search";
</style>
